import React from 'react';
import Svg, { Path } from 'react-native-svg';

export interface RefreshIconProps {
    size?: number;
    color?: string;
}

export const RefreshIcon = React.memo<RefreshIconProps>(function RefreshIcon({
    size = 19,
    color = '#1A1A1A',
}) {
    return (
        <Svg width={size} height={size} viewBox="0 0 19 19" fill="none">
            <Path
                d="M16.25 9.5C16.25 10.835 15.8541 12.1401 15.1124 13.2501C14.3707 14.3601 13.3165 15.2253 12.0831 15.7362C10.8497 16.2471 9.49252 16.3808 8.18314 16.1203C6.87377 15.8599 5.67104 15.217 4.72703 14.273C3.78303 13.329 3.14015 12.1262 2.8797 10.8169C2.61925 9.50749 2.75292 8.15029 3.26382 6.91689C3.77471 5.68349 4.63987 4.62928 5.7499 3.88758C6.85994 3.14588 8.16498 2.75 9.5 2.75C11.39 2.75 13.1975 3.5 14.555 4.805L16.25 6.5M16.25 6.5L16.25 2.75M16.25 6.5H12.5"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Svg>
    );
});

export default RefreshIcon;